import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-kanban-todos-group', {
  mixins: [eventListenerMixin],

  properties: {
    groupId: String,
    folded: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.kanban = document.querySelector('tr-project-kanban');
    this.cacheKey = `${window.location.pathname}${this.groupId}group_toggle`;

    this.listenTo(this, 'tr-todo-assignee-select-field:change', this.handleAssigneeChanged.bind(this));
    this.listenTo(this.querySelector('.js-toggle-todos'), 'click', this.handleToggle.bind(this));

    const storage = window.simple.util.storage.get(this.cacheKey);
    this.folded = storage === 'true';
  },

  ready() {
    this.initSortTodo();
  },

  handleAssigneeChanged() {
    this.kanban.reload();
  },

  handleToggle() {
    this.folded = !this.folded;
    window.simple.util.storage.set(this.cacheKey, this.folded);
  },

  initSortTodo() {
    const group = this;
    const $todolists = $(this).find('.group-todolist');

    $todolists.sortable({
      connectWith: `tr-kanban-todos-group[group-id="${group.groupId}"] .group-todolist`,
      distance: 5,
      scrollSensitivity: 100,
      items: 'tr-kanban-todo',
      placeholder: 'todo-placeholder',
      helper: 'clone',
      start(e, ui) {
        ui.placeholder.css({
          height: ui.helper.outerHeight(),
        });
      },
      stop(e, ui) {
        const $todo = ui.item;
        $.ajax({
          url: $todo.attr('reorder-url'),
          type: 'post',
          dataType: 'script',
          data: {
            todolist_guid: $todo.closest('.group-todolist').data('guid'),
            prev_todo_guid: $todo.prev('tr-kanban-todo').attr('guid'),
            next_todo_guid: $todo.next('tr-kanban-todo').attr('guid'),
          },
        });
      },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
